import { render, staticRenderFns } from "./vrste-troskova-vozila.editor.vue?vue&type=template&id=2f5da074&scoped=true&"
import script from "./vrste-troskova-vozila.editor.vue?vue&type=script&lang=ts&"
export * from "./vrste-troskova-vozila.editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5da074",
  null
  
)

export default component.exports